import moment from "moment";
import React from "react";

const Moment = ({date, format}) => {
  return <span>{moment(date).format(format || "llll")}</span>;
};
export default Moment;
